import { USER_PREFERENCE_CATEGORY } from '../user-preference/user-preference.interface';
import type { UserPreference } from '../user-preference/user-preference.interface';
import { baseDocumentFactory } from './base-document.factory';
import { ObjectFactory } from './object.factory';

export class UserPreferenceFactory extends ObjectFactory<UserPreference> {
  protected getDefaults(): UserPreference {
    return {
      ...baseDocumentFactory.build(),
      category: USER_PREFERENCE_CATEGORY.FRONTOFFICE,
      key: 'orders-table-hidden-columns',
      userId: 'aabbccddeeff001122334455',
      value: ['pickupSite', 'deliverySite'],
    };
  }
}

export const userPreferenceFactory = new UserPreferenceFactory();
